<template>
    <div class="position-relative has-tool-menu">
		<div class="tool-menu">
			<Breadcrumb />

			<div class="buttons">
				<ButtonAreas />

				<b-button v-if="module.access >= 30" variant="success" @click="newProduct"><span class="fa fa-plus"></span> Opret varegruppe</b-button>
			</div>
		</div>

		<b-card no-body>
			<div slot="header">
				<i class="fa fa-tags"></i> Varegrupper
				<div class="card-header-actions">
					<!-- <b-link href="#" class="card-header-action btn-setting">
						<i class="fa fa-cog"></i>
					</b-link> -->
				</div>
			</div>
			<DataTable ref="dataTable" v-if="fields" url="/api/module/products/productgroups" :fields="fields" name="productgroups" :filter="true">
				<template slot="5ce68ef5d6c2910bb09c58a5" slot-scope="{props}">
					<b-link append :to="props.row.Id">
						{{props.row["5ce68ef5d6c2910bb09c58a5"]}}
					</b-link>
				</template>
				<template slot="5ce68f0ad6c2910bb09c58a6" slot-scope="{props}">
						{{$user(props.row["5ce68f0ad6c2910bb09c58a6"]).name}}
				</template>
				<template slot="CreateDate" slot-scope="{props}">
					{{$moment(props.row.CreateDate).format("DD-MM-YYYY HH:mm")}}
				</template>
				<template slot="edit" slot-scope="{props}">
					<b-button append :to="props.row.Id" variant="primary"><i class="fa fa-eye"></i> Se mere</b-button>
				</template>
			</DataTable>
		</b-card>
	</div>
</template>

<script>
import newProductGroup from "./modals/_newProductGroup.vue";

export default {
	data: () => ({
		fields: null
	}),
	components: {},
	computed: {},
	methods: {
		newProduct() {
			this.$dialog.open(newProductGroup, { }, { title: "Opret varegruppe", okTitle: "Opret" })
		}
	},
	created() {
		this.$http.get("/api/module/products/fields/productgroup").then(x => {			
			this.fields = x.data;

			this.fields.push({
				name: "edit",
				visible: true,
				label: "",
				class: "text-right",
			});
		});
	},
	mounted() {}
};
</script>